import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import _ from 'lodash';
import { withStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import {
  Avatar,
  Box,
  Button,
  Divider,
  Drawer,
  Hidden,
  List,
  Typography
} from '@mui/material';
import {
  BarChart as BarChartIcon,
  Settings as SettingsIcon,
  File as FileIcon,
  User as UserIcon,
  Users as UsersIcon,
  BookOpen as BookOpenIcon
} from 'react-feather';
import NavItem from './NavItem';

const items = [
  {
    href: '/app/dashboard',
    icon: BarChartIcon,
    title: 'Dashboard',
    role: 'view-dashboard'
  },
  {
    href: '/app/customers',
    icon: UsersIcon,
    title: 'Customers',
    role: 'view-customers'
  },
  {
    href: '/app/acknowledgements',
    icon: BookOpenIcon,
    title: 'Acknowledgements',
    role: 'view-acknowledgements'
  },
  {
    href: '/app/invoices',
    icon: FileIcon,
    title: 'Invoices',
    role: 'view-invoices'
  },
  {
    href: '/app/account',
    icon: UserIcon,
    title: 'Account',
    role: 'view-account'
  },
  {
    href: '/app/settings',
    icon: SettingsIcon,
    title: 'Settings',
    role: 'view-settings'
  }
];

const useStyles = () => ({
  mobileDrawer: {
    width: 256
  },
  desktopDrawer: {
    width: 256,
    top: 64,
    height: 'calc(100% - 64px)'
  },
  avatar: {
    cursor: 'pointer',
    width: 64,
    height: 64
  }
});

class NavBar extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      userInfo: {},
      roles: []
    };
  }

  componentDidMount = async () => {
    const { keycloak } = this.props;
    const userInfo = await keycloak.idTokenParsed;
    const roles = _.get(keycloak, ['realmAccess', 'roles']);
    const photo = await window.localStorage.getItem('photo');
    _.set(userInfo, 'photo', photo);
    this.setState({ userInfo: _.cloneDeep(userInfo), roles });
  };

  /* eslint camelcase: ["error", {allow: ["^UNSAFE_"]}] */
  UNSAFE_componentWillReceiveProps = nextProps => {
    if (nextProps.openMobile && nextProps.onMobileClose) {
      nextProps.onMobileClose();
    }
  };

  content = () => {
    const { userInfo, roles } = this.state;
    const { classes } = this.props;

    return (
      <Box height="100%" display="flex" flexDirection="column">
        <Box alignItems="center" display="flex" flexDirection="column" p={2}>
          <Avatar
            className={classes.avatar}
            component={RouterLink}
            src={userInfo.photo}
            to="/app/account"
          >
            Unknown
          </Avatar>
          <Typography className={classes.name} color="textPrimary" variant="h5">
            {!_.isEmpty(userInfo)
              ? `${userInfo.name}`.toUpperCase()
              : 'Unknown'}
          </Typography>
          <Typography color="textSecondary" variant="body2">
            {!_.isEmpty(userInfo) ? userInfo.email : ' - '}
          </Typography>
        </Box>
        <Divider />
        <Box p={2}>
          <List>
            {_.map(items, item => {
              return _.includes(roles, item.role) ? (
                <NavItem
                  href={item.href}
                  key={item.title}
                  title={item.title}
                  icon={item.icon}
                />
              ) : null;
            })}
          </List>
        </Box>
        <Box flexGrow={1} />
        <Box p={2} m={2} bgcolor="background.dark">
          <Typography align="center" gutterBottom variant="h4">
            Need more?
          </Typography>
          <Typography align="center" variant="body2">
            Upgrade to PRO version to get access for adding records
          </Typography>
          <Box display="flex" justifyContent="center" mt={2}>
            <Button
              color="primary"
              component="a"
              href="https://billto.undash-cop.com"
              variant="contained"
            >
              See PRO version
            </Button>
          </Box>
        </Box>
      </Box>
    );
  };

  render() {
    const { classes, openMobile, onMobileClose } = this.props;

    return (
      <>
        <Hidden lgUp>
          <Drawer
            anchor="left"
            classes={{ paper: classes.mobileDrawer }}
            onClose={onMobileClose}
            open={openMobile}
            variant="temporary"
          >
            {this.content()}
          </Drawer>
        </Hidden>
        <Hidden mdDown>
          <Drawer
            anchor="left"
            classes={{ paper: classes.desktopDrawer }}
            open
            variant="persistent"
          >
            {this.content()}
          </Drawer>
        </Hidden>
      </>
    );
  }
}

NavBar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool,
  classes: PropTypes.any,
  keycloak: PropTypes.any
};

NavBar.defaultProps = {
  onMobileClose: () => {},
  openMobile: false
};

export default withStyles(useStyles)(NavBar);
